<template>
    <v-card :loading="loading" mx-4 min-height="250">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-card-title>
            {{ title }}
            <v-spacer></v-spacer>
            <v-btn
                v-if="hasAddNewButton"
                color="primary"
                dark
                class="ml-2"
                @click="addNewItem"
            >
                Adaugare
            </v-btn>
            <v-dialog
                v-else
                v-model="dialog"
                max-width="500px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dark
                        class="ml-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        Adaugare
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col md="12">
                                    <v-textarea
                                        v-model="form.comment"
                                        label="Nota"
                                        data-vv-as="Nota"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('comment')"
                                        :class="{ 'error--text': hasErrors('comment') }"
                                        class="primary--text"
                                        name="comment"
                                        data-vv-name="comment"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close"
                        >
                            Renuntare
                        </v-btn>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="save"
                        >
                            Salveaza
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
            :style="{minHeight: '500px'}"
        >
            <template v-slot:item.created_by="{ item }">
                {{ _.get(Static.employees.find(user => user.id === item.created_by), 'name', 'Nedefinit') }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    v-if="canUpdate(item)"
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    v-if="canDelete(item)"
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
    import SmartTable from "Components/SmartTable";
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    export default {
        mixins: [validationError],
        extends: SmartTable,
        props: {
            id: {
                type: [Number, String],
                required: true
            },
            type: {
                type: String,
                required: true
            },
            formTitle: {
                type: String,
                default() {
                    return "Adaugare nota"
                }
            }
        },
        data() {
            return {
                title: 'Note echipament',
                headers: [
                    {text: 'Nota', value: 'comment'},
                    {text: 'Adaugat de', value: 'created_by'},
                    {text: 'Actiuni', value: 'actions', sortable: false},
                ],
                form: new Form({
                    id: null,
                    subject_type: this.type,
                    subject_id: this.id,
                    comment: null
                }),
                defaultItem: {
                    id: null,
                    subject_type: this.type,
                    subject_id: this.id,
                    comment: null
                },
                dialog: false,
                dialogDelete: false,
            }
        },

        methods: {
            async initialize () {
                this.loading = true
                var query = this.$db.Comment
                    .where('subject_type', this.type)
                    .where('subject_id', this.id)
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                if(this.showTrashed) query = query.where('onlyTrashed', true)
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            async save() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;
                new this.$db.Comment(self.form)
                    .save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        this.close()
                        this.initialize()
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    self.form.busy = false;
                });
            },
            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.Comment) {
                    await item.delete().catch((err) => {
                        this.showError(err?.response?.data?.error)
                        throw err
                    })
                } else {
                    console.warn('Here comes the headache...')
                }
                this.dialogDelete = false
                await this.initialize()
            },
        },
    };
</script>
